import { Artist } from "./types";

/**
 * Dicionário de artistas/colaboradores do projeto.
 *
 * - Campos de perfil (fullName, role, type, description, image) alimentam a
 *   página /voadores/:slug (VoadorPage).
 * - `aliasOf` marca ids que são apenas variantes de grafia do mesmo artista
 *   (ex.: "luiz-g" -> "luis-gustavo"). Os ids continuam válidos para uso em
 *   `artistId`, mas os dados de perfil ficam no id canônico.
 */
export const artists: Record<string, Artist> = {
  "alice-portela": {
    "id": "alice-portela",
    "name": "Alice Portela",
    "role": "Design - UFRJ",
    "type": "Artista",
    "description": "Alice tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/alice.jpeg"
  },
  "ana-beatriz-brenha": {
    "id": "ana-beatriz-brenha",
    "name": "Ana Beatriz Brenha",
    "fullName": "Ana Beatriz Brenha Ribeiro",
    "role": "Pesquisa - UFRJ",
    "type": "Artista",
    "description": "Ana tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "ana-carolina-s": {
    "id": "ana-carolina-s",
    "name": "Ana Carolina S.",
    "fullName": "Ana Carolina dos Santos",
    "role": "Biologia - UFRJ",
    "type": "Artista",
    "description": "Ana tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "ana-clara-costa": {
    "id": "ana-clara-costa",
    "name": "Ana Clara Costa",
    "role": "Arte - UFRJ",
    "type": "Artista",
    "description": "Ana tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "camila-albuquerque": {
    "id": "camila-albuquerque",
    "name": "Camila Albuquerque",
    "role": "Educação - UFRJ",
    "type": "Artista",
    "description": "Camila tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/camila-voos.jpg"
  },
  "daniel": {
    "id": "daniel",
    "name": "Daniel",
    "aliasOf": "daniel-mello"
  },
  "daniel-mello": {
    "id": "daniel-mello",
    "name": "Daniel Mello",
    "fullName": "Daniel Mello",
    "role": "Fotografia - Aves do Valongo",
    "type": "Artista",
    "description": "Observador de aves e fotógrafo, coautor do guia 'As Aves do Valongo: visitantes e moradores'. Registra a avifauna urbana com dedicação à conservação e divulgação científica.",
    "image": "/pfps/anon.png"
  },
  "daniele-r": {
    "id": "daniele-r",
    "name": "Daniele R.",
    "fullName": "Danielle Ramos",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Danielle tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/danielle-ramos.jpg"
  },
  "fernanda-barbagelata": {
    "id": "fernanda-barbagelata",
    "name": "Fernanda Barbagelata",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Fernanda tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/Fernanda Barbagelata.png"
  },
  "fernanda-pontes": {
    "id": "fernanda-pontes",
    "name": "Fernanda Pontes",
    "fullName": "Fernanda C. Pontes",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Fernanda tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/fernanda-costa.jpeg"
  },
  "flavia-f": {
    "id": "flavia-f",
    "name": "Flavia F.",
    "fullName": "Flavia Fontes",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Flavia tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/flavia-fontes.jpg"
  },
  "flavia-m": {
    "id": "flavia-m",
    "name": "Flavia M.",
    "fullName": "Flávia Medeiros",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Flávia tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/Flavia-medeiros.jpeg"
  },
  "iolanda-lima": {
    "id": "iolanda-lima",
    "name": "Iolanda Lima",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Iolanda tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "isabela": {
    "id": "isabela",
    "name": "Isabela",
    "fullName": "Isabella Cristina",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Isabella tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "juliana-coutinho": {
    "id": "juliana-coutinho",
    "name": "Juliana Coutinho",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Juliana tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "lucas-mourao": {
    "id": "lucas-mourao",
    "name": "Lucas Mourão",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Lucas tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "luis-gustavo": {
    "id": "luis-gustavo",
    "name": "Luís Gustavo",
    "fullName": "Luis Gustavo Barreto",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Luis tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "luisa-melo": {
    "id": "luisa-melo",
    "name": "Luísa Melo",
    "fullName": "Luísa Melo",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Luísa é colaboradora do projeto Voos, registrando a avifauna através da fotografia.",
    "image": "/pfps/anon.png"
  },
  "luiz-g": {
    "id": "luiz-g",
    "name": "Luiz G.",
    "aliasOf": "luis-gustavo"
  },
  "luiz-gustavo": {
    "id": "luiz-gustavo",
    "name": "Luiz Gustavo",
    "aliasOf": "luis-gustavo"
  },
  "marcelle": {
    "id": "marcelle",
    "name": "Marcelle",
    "fullName": "Marcelle Sant'anna",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Marcelle tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "maria-napolitani": {
    "id": "maria-napolitani",
    "name": "Maria Napolitani"
  },
  "nathalia-p-izidio": {
    "id": "nathalia-p-izidio",
    "name": "Nathalia P. Izidio",
    "aliasOf": "nathalia-pereira-izidio"
  },
  "nathalia-pereira-izidio": {
    "id": "nathalia-pereira-izidio",
    "name": "Nathalia Pereira Izidio",
    "fullName": "Nathalia P. Izidio",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Nathalia tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/nathalia.jpeg"
  },
  "raphael": {
    "id": "raphael",
    "name": "Raphael",
    "fullName": "Raphael Albuquerque",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Raphael tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "saullo-storni": {
    "id": "saullo-storni",
    "name": "Saullo Storni",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Saullo tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "silvia-lorenz": {
    "id": "silvia-lorenz",
    "name": "Silvia Lorenz",
    "fullName": "Silvia Lorenz-Martins",
    "role": "Coordenação / Fotografia - UFRJ",
    "type": "Artista",
    "description": "Astrônoma, professora e vice-coordenadora do Projeto Voos na UFRJ. Apaixonada pela observação e registro fotográfico das aves que habitam os campi da universidade e a cidade do Rio de Janeiro.",
    "image": "/pfps/anon.png"
  },
  "silvia-lorenz-martins": {
    "id": "silvia-lorenz-martins",
    "name": "Silvia Lorenz-Martins",
    "aliasOf": "silvia-lorenz"
  },
  "suellen-m": {
    "id": "suellen-m",
    "name": "Suellen M.",
    "fullName": "Suellen R. Martins",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Suellen tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/suellen-voos.jpg"
  },
  "suzani": {
    "id": "suzani",
    "name": "Suzani",
    "aliasOf": "suzani-m"
  },
  "suzani-m": {
    "id": "suzani-m",
    "name": "Suzani M.",
    "fullName": "Suzani R. Martins",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Suzani tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/suzani-voos (2).jpg"
  },
  "thiago": {
    "id": "thiago",
    "name": "Thiago",
    "aliasOf": "thiago-t"
  },
  "thiago-t": {
    "id": "thiago-t",
    "name": "Thiago T.",
    "fullName": "Thiago Taubman",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Thiago tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/thiago-voos.jpg"
  },
  "yago-chedid": {
    "id": "yago-chedid",
    "name": "Yago Chedid",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Yago tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  },
  "yan-casares": {
    "id": "yan-casares",
    "name": "Yan Casares",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Yan tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ele une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/yan.jpg"
  },
  "yasmim-s": {
    "id": "yasmim-s",
    "name": "Yasmim S.",
    "aliasOf": "yasmim-santos"
  },
  "yasmim-santos": {
    "id": "yasmim-santos",
    "name": "Yasmim Santos",
    "fullName": "Yasmin Santos",
    "role": "Fotografia - UFRJ",
    "type": "Artista",
    "description": "Yasmin tem uma paixão especial por aves, que começou ainda na infância, observando pássaros no quintal de casa. Com o tempo, essa admiração se transformou em inspiração para sua arte. No projeto da UFRJ, ela une seu olhar atento de designer com o amor pela natureza, criando ilustrações que destacam a beleza e a diversidade das aves brasileiras. Cada traço é uma forma de expressar sua conexão com o mundo natural e de incentivar outras pessoas a valorizarem a vida selvagem.",
    "image": "/pfps/anon.png"
  }
};

/** Normaliza um nome para uso em URL: minúsculas, sem acentos, espaços -> "-". */
export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, "-");

export const getArtist = (id?: string): Artist | undefined =>
  id ? artists[id] : undefined;

/** Segue `aliasOf` e devolve o artista canônico (ou o próprio, se não for alias). */
export const resolveArtist = (artist?: Artist): Artist | undefined =>
  artist?.aliasOf ? artists[artist.aliasOf] ?? artist : artist;

/**
 * Resolve o parâmetro da rota /voadores/:slug. Aceita:
 *  - o id do artista (ex.: "ana-beatriz-brenha");
 *  - o nome normalizado (ex.: "ana-beatriz-brenha-ribeiro"), que é o formato
 *    gerado hoje por People e ArtistInfo — mantém os links existentes válidos.
 */
export const findArtistBySlug = (slug?: string): Artist | undefined => {
  if (!slug) return undefined;
  const list = Object.values(artists);
  const found =
    artists[slug] ??
    list.find((a) => slugify(a.fullName ?? a.name) === slug) ??
    list.find((a) => slugify(a.name) === slug);
  return resolveArtist(found);
};
